import { render, staticRenderFns } from "./RoleType.vue?vue&type=template&id=2552ac1f&"
import script from "./RoleType.vue?vue&type=script&lang=js&"
export * from "./RoleType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports